/**
 * Componente para la gestión integral de Competiciones,
 * incluyendo creación y edición de nombres.
 */
import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { AdminDataService } from '../../controller/admin-data.service';
import { CompetitionSyncItem } from '@solverml/api';

@Component({
  selector: 'app-competition-management',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './competition-management.component.html',
  styleUrls: ['../management-component.scss'] // Reutilizamos el SCSS compartido
})
export class CompetitionManagementComponent implements OnInit {

  public competitions: CompetitionSyncItem[] = [];
  public newCompetitionName: string = '';
  public isLoading: boolean = true;

  constructor(private adminDataService: AdminDataService) {}

  ngOnInit(): void {
    this.loadCompetitions();
  }

  /**
   * Carga la lista de competiciones desde el backend y la prepara para el formulario.
   */
  loadCompetitions(): void {
    this.isLoading = true;
    this.adminDataService.getCompetitions().subscribe(data => {
      this.competitions = data.map(c => ({ id: c.id, name: c.name }));
      this.isLoading = false;
    });
  }

  /**
   * Añade una nueva competición a la lista local, para ser creada al guardar.
   */
  addCompetition(): void {
    if (this.newCompetitionName.trim()) {
      this.competitions.push({ id: null, name: this.newCompetitionName.trim() });
      this.newCompetitionName = '';
    }
  }

  /**
   * Elimina una competición de la lista local.
   */
  removeCompetition(index: number): void {
    this.competitions.splice(index, 1);
  }

  /**
   * Envía la lista completa (con nombres y elementos nuevos/editados) al backend
   * para que la sincronice.
   */
  saveChanges(): void {
    this.isLoading = true;
    this.adminDataService.syncCompetitions(this.competitions).subscribe({
      next: (updatedCompetitions) => {
        this.competitions = updatedCompetitions.map(c => ({ id: c.id, name: c.name }));
        this.isLoading = false;
        // añadir una notificación de éxito
      },
      error: (err) => {
        console.error("Error al sincronizar las competiciones", err);
        this.isLoading = false;
      }
    });
  }
}
